import { render } from "./UserAuthentication.vue?vue&type=template&id=2f3486c1&scoped=true"
import script from "./UserAuthentication.vue?vue&type=script&lang=js"
export * from "./UserAuthentication.vue?vue&type=script&lang=js"

import "./UserAuthentication.vue?vue&type=style&index=0&id=2f3486c1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f3486c1"

export default script